module.exports = __webpack_public_path__ + "static/img/ig-button-v6.372f524.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/salepage/btn_social/ig-button-v6.gif
// module id = BG0B
// module chunks = 134